import { operatorsOf, } from '#src/rsql/policy.js';
export class RsqlPolicyError extends Error {
    constructor(message, position) {
        super(`posição ${position + 1}: ${message}`);
        this.name = 'RsqlPolicyError';
    }
}
const INTEGER = /^-?\d{1,15}$/;
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/** Data (`2026-10-23`) ou instante ISO 8601 com fuso. */
const DATETIME = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:\d{2}))?$/;
const toDate = (raw) => {
    const date = new Date(raw);
    return DATETIME.test(raw) && !Number.isNaN(date.getTime()) ? date : undefined;
};
const BOOLEANS = new Map([
    ['true', true],
    ['false', false],
]);
/** Do texto do filtro para o tipo do campo; `undefined` quando não serve. */
const CONVERTERS = {
    string: (raw) => raw,
    integer: (raw) => (INTEGER.test(raw) ? Number(raw) : undefined),
    uuid: (raw) => (UUID.test(raw) ? raw.toLowerCase() : undefined),
    enum: (raw, field) => field.values?.includes(raw) === true ? raw : undefined,
    boolean: (raw) => BOOLEANS.get(raw),
    datetime: toDate,
};
const convert = (raw, field) => CONVERTERS[field.type](raw, field);
const EXPECTED = {
    string: 'um texto',
    integer: 'um número inteiro',
    uuid: 'um UUID',
    enum: 'um dos valores do campo',
    boolean: 'true ou false',
    datetime: 'uma data ISO 8601, como 2026-10-23 ou 2026-10-23T09:00:00Z',
};
function checkComparison(node, policy) {
    const field = Object.hasOwn(policy.fields, node.selector)
        ? policy.fields[node.selector]
        : undefined;
    if (field === undefined) {
        throw new RsqlPolicyError(`o campo "${node.selector}" não é filtrável; campos: ${Object.keys(policy.fields).join(', ')}`, node.position);
    }
    const operators = operatorsOf(field);
    if (!operators.includes(node.operator)) {
        throw new RsqlPolicyError(`${node.selector} não aceita ${node.operator}; use ${operators.join(' ')}`, node.position);
    }
    const values = node.values.map((raw) => {
        const value = convert(raw, field);
        if (value === undefined) {
            const options = field.type === 'enum' ? ` (${field.values?.join(', ')})` : '';
            throw new RsqlPolicyError(`"${raw}" não serve para ${node.selector}: esperava ${EXPECTED[field.type]}${options}`, node.position);
        }
        return value;
    });
    const pattern = field.wildcards === true &&
        (node.operator === '==' || node.operator === '!=') &&
        node.values.some((raw) => raw.includes('*'));
    return {
        type: 'comparison',
        field: node.selector,
        operator: node.operator,
        values,
        pattern,
        caseInsensitive: field.caseInsensitive === true,
    };
}
/** Confere a árvore contra a lista branca. @throws RsqlPolicyError */
export function checkFilter(node, policy) {
    if (node.type === 'comparison') {
        return checkComparison(node, policy);
    }
    return {
        type: node.type,
        children: node.children.map((child) => checkFilter(child, policy)),
    };
}
//# sourceMappingURL=filter.js.map